module.exports = __webpack_public_path__ + "img/undraw_newspaper_k72w.74abfc2d.svg";